import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllTamaños_cajas() {
    const TamañosDB =  [];
    console.log("Hola");
    const collectionRef = collection(db, "Manifiestos/Tamaños_cajas/Productos/".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      TamañosDB.push(doc.data());
    });
    return TamañosDB;
    

}
